import { sourceUrl } from '../environment';

/**
 * Return distance between two coordinates
 *
 * @param {number} lat1
 * @param {number} lon1
 * @param {number} lat2
 * @param {number} lon2
 * @param {string} unit - M, K or N, default K
 */
export const returnDistance = (lat1, lon1, lat2, lon2, unit = 'K') => {
  if ((lat1 === lat2) && (lon1 === lon2)) {
    return 0;
  }
  else {
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === "K") { dist = dist * 1.609344 }
    if (unit === "N") { dist = dist * 0.8684 }
    return dist;
  }
}

export const createMarkers = (files, mergingDistance) => {
  const aggregated = []
  files.forEach((file) => {
    if(file.location && file.location.length === 2) {
      let merged = aggregated.some(marker => {

        const distance = returnDistance(file.location[1], file.location[0], marker.lat, marker.lng)
        if (distance < mergingDistance){
          marker.locations.push(file);
          marker.count += 1;
          return true
        }
        return false
      })
      if (!merged){
        aggregated.push({ _id: file._id, file, lng: file.location[0], lat: file.location[1], count: 1, locations : [file], images: file.images })
      }
    }
  })

  return aggregated
}

const _previewSizes = (count) => {
  switch(count) {
    case 1:
      return {
        thumbnailWidth: 320,
        thumbnailHeight: 200
      }
    case 2:
      return {
        thumbnailWidth: 180,
        thumbnailHeight: 200
      }
    case 3:
    case 4:
    default:
      return {
        thumbnailWidth: 180,
        thumbnailHeight: 200
      }

  }
}

export const createGalleryPreview = (images, limit) => {
  images = limit ? images.slice(0, limit) : images
  const thumbs =  images.map(image => ({
    src: sourceUrl + image,
    thumbnail: sourceUrl + image,
    ..._previewSizes(images.length)
  }))
  return thumbs
}

export const createGalleryImageObjects = (file, addCaption) => {
  return (file.images || []).map(image => ({
    src: sourceUrl + image,
    thumbnail: sourceUrl + image,
    thumbnailWidth: 1,
    thumbnailHeight: 1,
    caption: ( addCaption ? file.desc : ''),
    file
  }))
}


// WEBPACK FOOTER //
// ./src/util/index.js